import { Component, OnDestroy, OnInit } from "@angular/core";
import * as moment from "moment";
import { Observable } from "rxjs/Observable";

import { TranferStudentService } from "../../../../../client/app/internal/accomsupport/service/transfer-student.service";
import { TAAConstants } from "../../../../views/constants/taa-constants";
import { ExamineeRequestService } from "../../../../views/request/examinee/examinee-request.service";
import { HeaderService } from "../../../../views/services/header.service";
import { LandingService } from "../../../../views/services/landing.service";
import { RequestSubmitService } from "../../../../views/services/requestsubmit.service";
import { Country } from "../../../../views/shared/models/country";
import { SearchData } from "../../common/models/search";
import { InternalSendEmailService } from "../../common/services/internalsendemail.service";
import { ConsultantsService } from "../services/consultants.service";
import { AppService } from "../../../../views/services/app.service";
import { User } from "../../../../views/services/user.model";

@Component({
  selector: "app-landing",
  templateUrl: "./landing.component.html",
  styleUrls: ["./landing.component.css"]
})
export class LandingComponent implements OnInit, OnDestroy {
  public rscValues: any = [];
  public assignedData: any = [];
  public myRequestData: any = [];
  public completedData: any = [];
  public incompleteData: any = [];
  public deletedData: any = [];
  public autoApprovedData: any = [];
  public tests: any = [];
  public testDates: any = [];
  public currentTab: string;
  public tabList: string[];
  public tableData: any = {};
  public statusPanelData: any = {};
  public assigneeOptions: any;
  public personId: any;
  public consultant: any;
  public itemstoUpdate = [];
  public consultantId: any;
  public recordUpdate: boolean = false;
  public emptyItem: boolean = false;
  public emptyConsultant: boolean = false;
  public assignedStatusCode: string = "";
  public sizes: any;
  public countries: Country[];
  public selectedAll: any;
  public stateList: any = [];
  public searchData: SearchData = {};
  public retainedData: SearchData = {};
  public selected = [];
  public fromDateError: boolean = false;
  public fromAssignedDateError: boolean = false;
  public toAssignedDateError: boolean = false;
  public assignedDateError: boolean = false;
  public assignedDateErrorMsg: string = "";
  public toDateError: boolean = false;
  public dateError: boolean = false;
  public actIdError: boolean = false;
  public dateErrorMsg: string = "";
  public savedCurrentTab: string = "";
  public user: User;
  public disableStateCd: boolean = true;
  public loggedInConsultantId: any;
  public autoAppConsultantId: any;
  public searchclicked: boolean;
  public searchCount: number;
  public isNational: boolean;

  constructor(
    private tranferStudentService: TranferStudentService,
    private landingService: LandingService,
    private examineeRequestService: ExamineeRequestService,
    public internalSendEmailService: InternalSendEmailService,
    public requestSubmitService: RequestSubmitService,
    private analystsService: ConsultantsService,
    private appService: AppService,
    public taaConstants: TAAConstants
  ) {}

  ngOnInit() {
    this.disableStateCd = true;
    if (sessionStorage.getItem("tabName")) {
      sessionStorage.setItem("tabName", "");
    }
    this.appService.getUserProfile().then(user => (this.user = user));
    this.setSearchDefaultValue();
    this.tabList = [
      "unassigned",
      "assigned",
      "completed",
      "autoApproved",
      "incomplete",
      "deleted",
      "myRequests"
    ];

    // By default, we want to load the data from the unassigned tab
    this.handleTabChange("unassigned");

    Observable.forkJoin(
      this.examineeRequestService.getCountries(),
      this.tranferStudentService.getUsStateList(),
      this.analystsService.getActiveConsultants(),
      this.landingService.getRequestStatusCodes(),
      this.landingService.getTest()
    ).subscribe(([countries, state, resp, rsc, tests]) => {
      this.consultant = resp;
      this.countries = countries;
      this.stateList = state.body;
      this.stateList.sort((a, b) => (a.name > b.name ? 1 : -1));
      this.consultant.forEach((item, index, object) => {
        if (item.USER_NM === this.user.loggedInUser) {
          this.loggedInConsultantId = item.CONSULTANT_ID;
        }
        if (item.USER_NM === "SYSTEM") {
          this.autoAppConsultantId = item.CONSULTANT_ID;
          object.splice(index, 1);
        }
      });
      this.consultant.forEach(element => {
        this.landingService
          .getRequestCountByConsultantId(element.CONSULTANT_ID)
          .subscribe(response => {
            element.Count = response.body;
          });
      });

      this.rscValues = rsc;
      this.rscValues.forEach((item, index, object) => {
        if (item.STATUS_CD === "Assigned") {
          this.assignedStatusCode = item.REQUEST_STATUS_CODE_ID;
        }
      });
      this.tests = tests;
    });

    // Make the auto-approved api call to generate the status panel summary at the top
    this.landingService.getInternalCountData().subscribe(resp => {
      this.statusPanelData = this.calculateStatusPanelData(resp);
    });
  }
  ngOnDestroy() {}

  setSearchDefaultValue() {
    this.tableData = [];
    this.searchCount = 0;
    this.dateError = false;
    this.isNational = false;
    this.actIdError = false;
    this.toDateError = false;
    this.fromDateError = false;
    this.toAssignedDateError = false;
    this.fromAssignedDateError = false;
    this.assignedDateError = false;
    this.searchclicked = false;
    this.retainedData = this.landingService.getSearchResult();
    if (this.retainedData !== undefined && this.retainedData !== null) {
      this.searchData = this.retainedData;
      this.testDates = [];
      if (this.searchData.testNameId) {
        Observable.forkJoin(
          this.landingService.getTestDatesByTest(this.searchData.testNameId)
        ).subscribe(([testDates]) => {
          this.testDates = testDates.body;
        });
      }
      this.checkSearch();
    } else {
      this.searchData.status = "";
      this.searchData.consultantId = "";
      this.searchData.testDateId = "";
      this.searchData.testNameId = "";
      this.searchData.fromDate = "";
      this.searchData.firstNm = "";
      this.searchData.lastNm = "";
      this.searchData.taaPin = "";
      this.searchData.actId = "";
      this.searchData.studentStateId = "";
      this.searchData.zipCode = "";
      this.searchData.countryCd = "";
      this.searchData.stateCd = "";
      this.searchData.city = "";
      this.searchData.organizationName = "";
      this.searchData.toDate = "";
      this.searchData.fromAssignedDate = "";
      this.searchData.toAssignedDate = "";
    }
  }

  getCountrySelection() {
    this.searchData.stateCd = "";
    this.isNational = false;
    if (this.searchData.countryCd === "US") {
      this.isNational = true;
    } else if (this.searchData.countryCd === "") {
      this.disableStateCd = true;
    } else {
      this.disableStateCd = false;
    }
  }

  handleTabChange(tabID) {
    this.emptyItem = false;
    this.emptyConsultant = false;
    if (tabID === "myRequests") {
      this.currentTab = tabID;
    } else if (tabID === "completed") {
      this.currentTab = tabID;
    } else if (tabID === "assigned") {
      this.currentTab = tabID;
    } else if (tabID === "autoApproved") {
      this.currentTab = tabID;
    } else if (tabID === "incomplete") {
      this.currentTab = tabID;
    } else if (tabID === "deleted") {
      this.currentTab = tabID;
    } else if (tabID === "unassigned") {
      this.selectedAll = false;
      this.selectAll();
      if (!this.searchclicked) {
        this.testDates = [];
        this.searchData = {};
        this.setSearchDefaultValue();
        this.currentTab = tabID;
        this.landingService
          .getInternalScreenData(this.currentTab, null)
          .subscribe(response => {
            this.tableData = response.body;
            this.tableData.forEach(element => {
              if (element.REASONS) {
                element.REASONS = element.REASONS.replace(/\|/g, ",");
              }
              if (element.EXAMINEE_ACCOMMS) {
                element.EXAMINEE_ACCOMMS = element.EXAMINEE_ACCOMMS.replace(
                  /\|/g,
                  ","
                );
              }
              if (element.CONSULTANTS) {
                element.CONSULTANTS = element.CONSULTANTS.replace(/\|/g, ",");
              }
            });
          });
      } else {
        this.currentTab = tabID;
      }
    }
  }

  handleAssignTo() {
    this.recordUpdate = false;
    if (this.itemstoUpdate.length === 0) {
      this.emptyConsultant = false;
      this.emptyItem = true;
    } else if (!this.consultantId) {
      this.emptyItem = false;
      this.emptyConsultant = true;
    } else {
      const payload: any = [];
      this.emptyConsultant = false;
      this.emptyItem = false;
      const consultantId = this.consultantId;
      this.itemstoUpdate.forEach(element => {
        const res = {
          CONSULTANT_ID: this.consultantId,
          REQUEST_STATUS_CODE_ID: this.assignedStatusCode,
          REQUEST_ID: element.REQUEST_ID,
          STATUS_CD: element.STATUS_CD,
          previousReviewers: element.CONSULTANTS
        };
        payload.push(res);
      });
      const observables = [];
      payload.forEach(item => {
        observables.push(this.landingService.assignTo(item));
      });
      Observable.forkJoin(observables).subscribe(
        ([response]) => {
          this.recordUpdate = true;
          this.consultantId = undefined;
          this.ngOnInit();
          Observable.forkJoin(
            this.internalSendEmailService.requestAssigned(consultantId)
          ).subscribe(([resp]) => {
            const rtn: any = resp;
            if (
              rtn.status === 200 ||
              rtn.status === 201 ||
              rtn.status === 204
            ) {
              console.log("Assigned Email sent: " + rtn.status);
            }
          });
        },
        error => {
          console.log(error);
        }
      );
    }
    this.itemstoUpdate = [];
  }

  onCheckedChange(event, item) {
    if (event) {
      this.itemstoUpdate.push(item);
    } else {
      const index: number = this.itemstoUpdate.indexOf(item);
      if (index !== -1) {
        this.itemstoUpdate.splice(index, 1);
      }
    }
  }

  selectAll() {
    this.itemstoUpdate = [];
    for (let i = 0; i < this.tableData.length; i++) {
      this.tableData[i].selected = this.selectedAll;
      if (this.tableData[i].selected === true) {
        this.itemstoUpdate.push(this.tableData[i]);
      }
    }
  }

  // Feel free to refactor if better way exists to access the keys directly in the html file
  getKeys(obj) {
    return Object.keys(obj);
  }

  // String manipulation didn't work directly in html using string interpolation (angular problem)
  reformatCamelCase(str) {
    return str.replace(/([A-Z])/g, " $1").replace(/^./, function(newstr) {
      return newstr.toUpperCase();
    });
  }

  // Dynamically creates an object that associates a test name to the number of time it appears in the response; used for status panel above the tabs
  calculateStatusPanelData(data) {
    const count = {};

    for (let i = 0; i < data.length; i++) {
      if (count[data[i].TEST_NM]) {
        if (
          data[i].STATUS_CD === "AutoApproved" ||
          data[i].STATUS_CD === "Approved"
        ) {
          count[data[i].TEST_NM] = count[data[i].TEST_NM] + data[i].COUNTS;
        }
      } else {
        count[data[i].TEST_NM] = 0;
        if (
          data[i].STATUS_CD === "AutoApproved" ||
          data[i].STATUS_CD === "Approved"
        ) {
          count[data[i].TEST_NM] = count[data[i].TEST_NM] + data[i].COUNTS;
        }
      }
    }
    return count;
  }
  sendStudentDetails(examinee: any) {
    const studentDetails = {
      personId: examinee.PERSON_ID,
      requestId: examinee.REQUEST_ID,
      consultantId: examinee.CONSULTANT_ID ? examinee.CONSULTANT_ID : "",
      taaPin: examinee.ACCOMMS_PIN ? examinee.ACCOMMS_PIN : "",
      organizationName: examinee.ORGANIZATION_NM
        ? examinee.ORGANIZATION_NM
        : "",
      firstNm: examinee.PNFIRSTNAME ? examinee.PNFIRSTNAME : "",
      lastNm: examinee.PNLASTNAME ? examinee.PNLASTNAME : ""
    };
    sessionStorage.setItem(
      "internalStudentDetails",
      JSON.stringify(studentDetails)
    );
  }
  onSelectedDropDownValue() {
    this.testDates = [];
    Observable.forkJoin(
      this.landingService.getTestDatesByTest(this.searchData.testNameId)
    ).subscribe(([testDates]) => {
      this.testDates = testDates.body;
    });
  }
  search() {
    if (this.searchData.firstNm) {
      this.searchData.firstNm = this.searchData.firstNm.trim();
    }
    if (this.searchData.lastNm) {
      this.searchData.lastNm = this.searchData.lastNm.trim();
    }
    if (this.searchData.taaPin) {
      this.searchData.taaPin = this.searchData.taaPin.trim();
    }
    if (this.searchData.city) {
      this.searchData.city = this.searchData.city.trim();
    }
    if (this.searchData.stateCd) {
      this.searchData.stateCd = this.searchData.stateCd.trim();
      this.isNational = true;
    }
    if (this.searchData.zipCode) {
      this.searchData.zipCode = this.searchData.zipCode.trim();
    }
    if (this.searchData.studentStateId) {
      this.searchData.studentStateId = this.searchData.studentStateId.trim();
    }

    Observable.forkJoin(
      this.landingService.getSearchData(this.searchData),
      this.landingService.getSearchCount(this.searchData)
    )
      .finally(() => {
        this.currentTab = "unassigned";
      })
      .subscribe(([response, count]) => {
        if (count) {
          this.searchCount = count.body[0]["COUNT(*)"];
        }
        if (response) {
          this.recordUpdate = false;
          this.tableData = [];
          this.assignedData = [];
          this.completedData = [];
          this.autoApprovedData = [];
          this.myRequestData = [];
          this.incompleteData = [];
          this.deletedData = [];
          const result: any = response.body;
          result.forEach(element => {
            if (element.REASONS) {
              element.REASONS = element.REASONS.replace(/\|/g, ",");
            }
            if (element.EXAMINEE_ACCOMMS) {
              element.EXAMINEE_ACCOMMS = element.EXAMINEE_ACCOMMS.replace(
                /\|/g,
                ","
              );
            }
            if (element.CONSULTANTS) {
              element.CONSULTANTS = element.CONSULTANTS.replace(/\|/g, ",");
            }
            if (
              element.STATUS_CD === "Pending" ||
              element.STATUS_CD === "Reconsider" ||
              element.STATUS_CD === "ExternallyReviewed"
            ) {
              this.tableData.push(element);
            }
            if (
              element.STATUS_CD === "Assigned" ||
              element.STATUS_CD === "InReview"
            ) {
              this.assignedData.push(element);
            }
            if (
              element.STATUS_CD === "Approved" ||
              element.STATUS_CD === "NotApproved" ||
              element.STATUS_CD === "PartiallyApproved"
            ) {
              this.completedData.push(element);
            }
            if (element.STATUS_CD === "AutoApproved") {
              this.autoApprovedData.push(element);
            }
            if (
              (element.STATUS_CD === "Assigned" ||
                element.STATUS_CD === "InReview") &&
              element.CONSULTANT_ID === this.loggedInConsultantId
            ) {
              this.myRequestData.push(element);
            }
            if (element.STATUS_CD === "Incomplete" ||
            element.STATUS_CD === "ReconsiderIncomplete") {
              this.incompleteData.push(element);
            }
            if (element.STATUS_CD === "Deleted") {
              this.deletedData.push(element);
            }
          });
        }
      });
  }

  checkSearch() {
    this.searchclicked = false;
    this.toDateError = false;
    this.actIdError = false;
    this.dateError = false;
    this.toAssignedDateError = false;
    this.fromAssignedDateError = false;
    this.fromDateError = false;
    this.toAssignedDateError = false;
    this.fromAssignedDateError = false;
    this.assignedDateError = false;
    this.fromDateError = false;
    for (let i = 0; i < Object.keys(this.searchData).length; i++) {
      if (this.searchData[Object.keys(this.searchData)[i]]) {
        this.searchclicked = true;
        break;
      }
    }

    if (this.searchclicked) {
      if (this.searchData.actId) {
        this.searchData.actId = this.searchData.actId.replace(/-/gi, "");
        const pattern = /[0-9]{8,9}$/;
        const regex = new RegExp(pattern);
        if (
          !(
            this.searchData.actId.length === 8 ||
            this.searchData.actId.length === 9
          ) ||
          regex.test(this.searchData.actId) === false
        ) {
          this.actIdError = true;
        }
      }
      if (this.searchData.fromDate && this.searchData.fromDate !== null) {
        this.searchData.fromDate = moment(this.searchData.fromDate).format(
          "MM-DD-YYYY"
        );
        if (this.searchData.fromDate === "Invalid date") {
          this.fromDateError = true;
        } else {
          this.fromDateError = false;
        }
      }
      if (this.searchData.toDate && this.searchData.toDate !== null) {
        this.searchData.toDate = moment(this.searchData.toDate).format(
          "MM-DD-YYYY"
        );
        if (this.searchData.toDate === "Invalid date") {
          this.toDateError = true;
        } else {
          this.toDateError = false;
        }
      }
      if (
        this.searchData.fromDate &&
        this.searchData.toDate &&
        this.searchData.fromDate !== null &&
        this.searchData.toDate !== null
      ) {
        if (
          moment(this.searchData.toDate).isAfter(this.searchData.fromDate) ||
          moment(this.searchData.toDate).isSame(this.searchData.fromDate)
        ) {
          this.dateError = false;
        } else {
          this.dateError = true;
          this.dateErrorMsg = "From Date must be earlier than the To date";
        }
      } else if (this.searchData.fromDate && !this.searchData.toDate) {
        this.dateError = true;
        this.dateErrorMsg = "Please select a Submitted To Date";
      } else if (!this.searchData.fromDate && this.searchData.toDate) {
        this.dateError = true;
        this.dateErrorMsg = "Please select a Submitted From Date";
      }
      if (
        this.searchData.fromAssignedDate &&
        this.searchData.fromAssignedDate !== null
      ) {
        this.searchData.fromAssignedDate = moment(
          this.searchData.fromAssignedDate
        ).format("MM-DD-YYYY");
        if (this.searchData.fromAssignedDate === "Invalid date") {
          this.fromAssignedDateError = true;
        } else {
          this.fromAssignedDateError = false;
        }
      }
      if (
        this.searchData.toAssignedDate &&
        this.searchData.toAssignedDate !== null
      ) {
        this.searchData.toAssignedDate = moment(
          this.searchData.toAssignedDate
        ).format("MM-DD-YYYY");
        if (this.searchData.toAssignedDate === "Invalid date") {
          this.toAssignedDateError = true;
        } else {
          this.toAssignedDateError = false;
        }
      }
      if (
        this.searchData.fromAssignedDate &&
        this.searchData.toAssignedDate &&
        this.searchData.fromAssignedDate !== null &&
        this.searchData.toAssignedDate !== null
      ) {
        if (
          moment(this.searchData.toAssignedDate).isAfter(
            this.searchData.fromAssignedDate
          ) ||
          moment(this.searchData.toAssignedDate).isSame(
            this.searchData.fromAssignedDate
          )
        ) {
          this.assignedDateError = false;
        } else {
          this.assignedDateError = true;
          this.assignedDateErrorMsg =
            "From Date must be earlier than the To date";
        }
      } else if (
        this.searchData.fromAssignedDate &&
        !this.searchData.toAssignedDate
      ) {
        this.assignedDateError = true;
        this.assignedDateErrorMsg = "Please select an assigned To Date";
      } else if (
        !this.searchData.fromAssignedDate &&
        this.searchData.toAssignedDate
      ) {
        this.assignedDateError = true;
        this.assignedDateErrorMsg = "Please select an assigned From Date";
      }
      if (
        !(
          this.assignedDateError ||
          this.toAssignedDateError ||
          this.fromAssignedDateError
        ) &&
        !(this.dateError || this.toDateError || this.fromDateError)
      ) {
        this.search();
      }
    } else {
      document.getElementById("searchModal").style.display = "block";
    }
    this.landingService.setSearchResult(this.searchData);
  }
  clearForm() {
    this.landingService.setSearchResult(null);
    this.ngOnInit();
  }
  onCloseHandled(id) {
    document.getElementById(id).style.display = "";
    this.clearForm();
  }
}



// WEBPACK FOOTER //
// ./client/app/internal/accmgr/landing/landing.component.ts